const endSubscriptionErrorOther = {
    bindings: {},
    template: require('./endSubscriptionErrorOther.jade')(),
    /** @ngInject */ controller(MailAdresses, ContactTelephone) {
        const ctrl = this
        ctrl.MailAdresses = MailAdresses
        ctrl.contactTelephone = ContactTelephone.anonymous
    },
}

export default endSubscriptionErrorOther



// WEBPACK FOOTER //
// ./src/states/endSubscription/component/endSubscriptionErrorOther.js